import React, { useMemo } from 'react';
const thermometerStyling = (id: string, color: string) => {
  const style = `.thermometer-${id} .thermometer-${id}__mercury {
    transition: all .5s ease-in-out; }
  
  .thermometer-${id} .thermometer-${id}__percent-current:before, .thermometer-${id} .thermometer-${id}__percent-current:after, .thermometer-${id} .thermometer-${id}__draw-b:after, .thermometer-${id}__draw-bReverse:after, .thermometer-${id} .thermometer-${id}__draw-b:before, .thermometer-${id}__draw-bReverse:before {
    content: "";
    margin: auto; 
  }
  
  .thermometer-${id} ul.thermometer-${id}__statistics {
    font-size: 11px;
    font-style: italic;
    font-weight: 500; }
  
  .thermometer-${id} .thermometer-${id}__percent-current {
    font-size: 10px;
    font-style: normal;
    font-weight: 500; }
  
  .thermometer-${id} ul.thermometer-${id}__statistics {
    margin: 0;
    padding: 0; }
  
  .thermometer-${id}--small ul.thermometer-${id}__statistics li {
    width: 150px;
    padding-left: 8px; }
  
  .thermometer-${id}--small .thermometer-${id}__draw-a {
    width: 14px; }
    .thermometer-${id}--small .thermometer-${id}__draw-a:after {
      position: absolute;
      top: initial;
      right: initial;
      bottom: -12px;
      left: -10px;
      width: 34px;
      height: 34px; }
  
  .thermometer-${id}--small .thermometer-${id}__draw-b:before {
    width: 4px; }
  
  .thermometer-${id}--small .thermometer-${id}__draw-b:after {
    position: absolute;
    top: 13px;
    right: 0;
    bottom: initial;
    left: 0;
    width: 24px;
    height: 24px; }
  
  .thermometer-${id}--small .thermometer-${id}__draw-bReverse:before {
    width: 4px; }
  
  .thermometer-${id}--small .thermometer-${id}__draw-bReverse:after {
    position: absolute;
    top: 13px;
    right: 0;
    bottom: initial;
    left: 0;
    width: 24px;
    height: 24px; }
  
  .thermometer-${id}--small .thermometer-${id}__meter {
    width: 4px; }
  
  .thermometer-${id}--normal ul.thermometer-${id}__statistics li {
    width: 150px;
    padding-left: 13px; }
  
  .thermometer-${id}--normal .thermometer-${id}__draw-a {
    width: 30px; }
    .thermometer-${id}--normal .thermometer-${id}__draw-a:after {
      position: absolute;
      top: initial;
      right: initial;
      bottom: -20px;
      left: -10px;
      width: 50px;
      height: 50px; }
  
  .thermometer-${id}--normal .thermometer-${id}__draw-b:before {
    width: 10px; }
  
  .thermometer-${id}--normal .thermometer-${id}__draw-b:after {
    position: absolute;
    top: 8px;
    right: 0;
    bottom: initial;
    left: 0;
    width: 34px;
    height: 34px; }
  
  .thermometer-${id}--normal .thermometer-${id}__draw-bReverse:before {
    width: 10px; }
  
  .thermometer-${id}--normal .thermometer-${id}__draw-bReverse:after {
    position: absolute;
    top: 8px;
    right: 0;
    bottom: initial;
    left: 0;
    width: 34px;
    height: 34px; }
  
  .thermometer-${id}--normal .thermometer-${id}__meter {
    width: 10px; }
  
  .thermometer-${id}--large ul.thermometer-${id}__statistics li {
    width: 150px;
    padding-left: 34px; }
  
  .thermometer-${id}--large .thermometer-${id}__draw-a {
    width: 50px; }
    .thermometer-${id}--large .thermometer-${id}__draw-a:after {
      position: absolute;
      top: initial;
      right: initial;
      bottom: -30px;
      left: -10px;
      width: 70px;
      height: 70px; }
  
  .thermometer-${id}--large .thermometer-${id}__draw-b:before {
    width: 30px; }
  
  .thermometer-${id}--large .thermometer-${id}__draw-b:after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: initial;
    left: 0;
    width: 50px;
    height: 50px; }
  
  .thermometer-${id}--large .thermometer-${id}__draw-bReverse:before {
    width: 30px; }
  
  .thermometer-${id}--large .thermometer-${id}__draw-bReverse:after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: initial;
    left: 0;
    width: 50px;
    height: 50px; }
  
  .thermometer-${id}--large .thermometer-${id}__meter {
    width: 30px; }
  
  .thermometer-${id}--theme-light .thermometer-${id}__draw-a, .thermometer-${id}--theme-light .thermometer-${id}__draw-a:before, .thermometer-${id}--theme-light .thermometer-${id}__draw-a:after {
    background-color: #fff; }
  
  .thermometer-${id}--theme-light .thermometer-${id}__meter {
    background-color: #d6d6d6; }
  
  .thermometer-${id}--theme-light ul.thermometer-${id}__statistics li {
    color: #000; }
    .thermometer-${id}--theme-light ul.thermometer-${id}__statistics li:before {
      background: linear-gradient(90deg, rgba(0, 0, 0, 0.2), transparent); }
  
  .thermometer-${id}--theme-light .thermometer-${id}__percent-current {
    color: #000;
    background-color: #fff; }
    .thermometer-${id}--theme-light .thermometer-${id}__percent-current:after {
      border-left: 8px solid #fff; }
  
  .thermometer-${id}--theme-dark .thermometer-${id}__draw-a, .thermometer-${id}--theme-dark .thermometer-${id}__draw-a:before, .thermometer-${id}--theme-dark .thermometer-${id}__draw-a:after {
    background-color: #333; }
  
  .thermometer-${id}--theme-dark .thermometer-${id}__meter {
    background-color: #1d1d1d; }
  
  .thermometer-${id}--theme-dark ul.thermometer-${id}__statistics li {
    color: #fff; }
    .thermometer-${id}--theme-dark ul.thermometer-${id}__statistics li:before {
      background: linear-gradient(90deg, rgba(255, 255, 255, 0.2), transparent); }
  
  .thermometer-${id}--theme-dark .thermometer-${id}__percent-current {
    color: #fff;
    background-color: #1d1d1d; }
    .thermometer-${id}--theme-dark .thermometer-${id}__percent-current:after {
      border-left: 8px solid #1d1d1d; }
  
  .thermometer-${id} {
    width: 100px;
    position: relative; }
    .thermometer-${id} ul.thermometer-${id}__statistics {
      position: absolute;
      top: 0;
      right: initial;
      bottom: initial;
      left: 0;
      height: 100%;
      z-index: 1; }
      .thermometer-${id} ul.thermometer-${id}__statistics li {
        position: absolute;
        top: initial;
        right: initial;
        bottom: initial;
        left: 0;
        list-style: none; }
        .thermometer-${id} ul.thermometer-${id}__statistics li:before {
          position: absolute;
          top: initial;
          right: initial;
          bottom: -1px;
          left: 0;
          content: "";
          width: 100%;
          height: 1px; }
    .thermometer-${id} .thermometer-${id}__meter {
      position: absolute;
      top: 12px;
      right: 0;
      bottom: initial;
      left: 0;
      height: calc(100% - 58px);
      margin: auto;
      border-radius: 50px 50px 0 0;
      z-index: 1; }
    .thermometer-${id} .thermometer-${id}__mercury {
      position: absolute;
      top: initial;
      right: initial;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 0;
      border-radius: 50px 50px 0 0; }
    .thermometer-${id} .thermometer-${id}__mask {
      position: absolute;
      top: initial;
      right: initial;
      bottom: -1px;
      left: initial;
      overflow: hidden;
      width: 100%;
      height: 100%;
      border-radius: 50px 50px 0 0; }
    .thermometer-${id} .thermometer-${id}__bg-color {
      position: absolute;
      top: initial;
      right: initial;
      bottom: 0;
      left: initial;
      width: 100px;
      background: linear-gradient(${color}, ${color}, ${color}); }
    .thermometer-${id} .thermometer-${id}__bg-colorReverse {
      position: absolute;
      top: initial;
      right: initial;
      bottom: 0;
      left: initial;
      width: 100px;
      background: linear-gradient(${color}, ${color}, ${color}); }
    .thermometer-${id} .thermometer-${id}__percent-current {
      position: absolute;
      top: 4px;
      right: initial;
      bottom: initial;
      left: 0;
      transform: translateX(calc(-100% - 8px)) translateY(-50%);
      padding: 5px 10px;
      border-radius: 2px;
      box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1), 3px 3px 6px rgba(0, 0, 0, 0.1); }
      .thermometer-${id} .thermometer-${id}__percent-current:before, .thermometer-${id} .thermometer-${id}__percent-current:after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: initial;
        width: 0;
        height: 0; }
      .thermometer-${id} .thermometer-${id}__percent-current:after {
        border-top: 6px solid transparent;
        border-bottom: 6px solid transparent;
        transform: translateX(calc(100% - 2px)) translateY(0); }
      .thermometer-${id} .thermometer-${id}__percent-current:before {
        border-left: 8px solid rgba(0, 0, 0, 0.1);
        border-top: 6px solid transparent;
        border-bottom: 6px solid transparent;
        transform: translateX(calc(100% - 0px)) translateY(0); }
    .thermometer-${id} .thermometer-${id}__draw-a {
      position: relative;
      height: calc(100% - 20px);
      margin: auto;
      border-radius: 50px 50px 0 0;
      box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05), 1px 1px 5px rgba(0, 0, 0, 0.2); }
      .thermometer-${id} .thermometer-${id}__draw-a:after, .thermometer-${id} .thermometer-${id}__draw-a:before {
        content: ""; }
      .thermometer-${id} .thermometer-${id}__draw-a:before {
        position: absolute;
        top: initial;
        right: initial;
        bottom: 0;
        left: 0;
        height: 50px;
        width: 100%;
        z-index: 1; }
      .thermometer-${id} .thermometer-${id}__draw-a:after {
        border-radius: 50%;
        box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05), 1px 1px 5px rgba(0, 0, 0, 0.2); }
    .thermometer-${id} .thermometer-${id}__draw-b {
      position: absolute;
      top: initial;
      right: 0;
      bottom: 0;
      left: 0;
      width: 50px;
      height: 50px;
      margin: auto;
      z-index: 1; }
      .thermometer-${id} .thermometer-${id}__draw-b:after {
        background-color: ${color};
        border-radius: 50%; }
      .thermometer-${id} .thermometer-${id}__draw-b:before {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 40px;
        left: 0;
        background-color: ${color};
        border-radius: 50px 50px 0 0; }
    .thermometer-${id} .thermometer-${id}__draw-bReverse {
      position: absolute;
      top: initial;
      right: 0;
      bottom: 0;
      left: 0;
      width: 50px;
      height: 50px;
      margin: auto;
      z-index: 1; }
      .thermometer-${id} .thermometer-${id}__draw-bReverse:after {
        background-color: #2196f3;
        border-radius: 50%; }
      .thermometer-${id} .thermometer-${id}__draw-bReverse:before {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 40px;
        left: 0;
        height: 20px;
        background-color: #2196f3;
        border-radius: 50px 50px 0 0; }
        
      .left-align {
        left: -140px !important;
      }

      .right-align {
        padding-left: 30px !important;
      }  
      
      `;

  return <style>{style}</style>;
};

interface ThermometerProps {
  id: string;
  color: string;
  theme?: 'light' | 'dark';
  value: number;
  max: number;
  target: number;
  stretch: number;
  size?: 'small' | 'normal' | 'large';
  height?: number;
  targetLabel: string;
  stretchLabel: string;
}

interface Interval {
  percent: number;
  label: string;
  useLeft: boolean;
}

export default function ThermometerComponent({
  id,
  color,
  theme = 'light',
  value = 0,
  max = 100,
  size = 'normal',
  height = 200,
  target = 0,
  stretch = 0,
  targetLabel = 'Target',
  stretchLabel = 'Strech',
}: ThermometerProps) {
  const options = useMemo(() => {
    const percent = (value / max) * 100;
    const valstr = `${value}`;
    const themeClass = theme === 'light' || theme === 'dark' ? theme : 'light';
    const sizeClass = size === 'small' || size === 'normal' || size === 'large' ? size : 'normal';

    return { themeClass, sizeClass, height, percent, valstr };
  }, [theme, value, max, size, height]);

  const intervals = useMemo(() => {
    const createInterval = (value: number, max: number, labelPrefix: string): Interval | null => {
      if (value <= 0) return null;
      return {
        percent: (value / max) * 100,
        label: `${labelPrefix} - ${Intl.NumberFormat('en-US').format(value)}`,
        useLeft: false,
      };
    };

    let intervalList: Interval[] = [];

    if (target === stretch) {
      const target = createInterval(stretch, max, targetLabel);
      if (target) {
        intervalList.push(target);
      }
      const forecast = createInterval(value, max, 'Forecast');
      if (forecast) {
        intervalList.push(forecast);
      }
    } else {
      intervalList = [
        createInterval(value, max, 'Forecast'),
        createInterval(target, max, targetLabel),
        createInterval(stretch, max, stretchLabel),
      ].filter(Boolean) as Interval[];
    }

    const forecastInterval = intervalList.find((interval) => interval.label.startsWith('Forecast'));

    if (forecastInterval) {
      const forecastValue = parseFloat(forecastInterval.label.split(' - ')[1].replace(/,/g, ''));

      for (const interval of intervalList) {
        if (
          (interval.label.startsWith(targetLabel) || interval.label.startsWith(stretchLabel)) &&
          Math.abs(forecastValue - parseFloat(interval.label.split(' - ')[1].replace(/,/g, ''))) <=
            2500
        ) {
          forecastInterval.useLeft = true;
          break;
        }
      }
    }

    return intervalList;
  }, [max, target, stretch, value]);

  const stepIntervalsUI = intervals.map((step, i) => {
    if (step.useLeft) {
      return (
        <li
          key={i}
          style={{ bottom: `calc(${step.percent}% - 1px)`, left: '-100px !important' }}
          className={step.useLeft ? 'left-align' : ''}
        >
          {step.label}
        </li>
      );
    } else {
      return (
        <li
          key={i}
          style={{ bottom: `calc(${step.percent}% - 1px)` }}
          className={!step.useLeft ? 'right-align' : ''}
        >
          {step.label}
        </li>
      );
    }
  });

  return (
    <>
      {thermometerStyling(id, color)}
      <div
        style={{ height: `${options.height}px` }}
        className={`thermometer-${id} thermometer-${id}--${options.sizeClass} thermometer-${id}--theme-${options.themeClass}`}
      >
        <div className={`thermometer-${id}__draw-a`}></div>
        <div className={`thermometer-${id}__draw-b`}></div>
        <div className={`thermometer-${id}__meter`}>
          <ul className={`thermometer-${id}__statistics`}>{stepIntervalsUI}</ul>
          <div style={{ height: `${options.percent}%` }} className={`thermometer-${id}__mercury`}>
            {/* <div className="thermometer__percent-current">{options.valstr}</div> */}
            <div className={`thermometer-${id}__mask`}>
              <div
                className={`thermometer-${id}__bg-color`}
                style={{ height: `calc(${options.height}px - 57px)` }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
